/**
 * Значения контроллеров ячеек таблицы, от которых зависит то,
 * как и какие типы данных мы будем забивать в ячейки
 */
export enum CellControllerKind {
  TEXT = 'text' /** Текст, (нередактируемый) */,
  NUMBER = 'number' /* Число ( нередактируемое ) */,
  SELECT = 'select' /** Выбор из множества значений */,
  INPUT_STRING = 'input-string' /* Ввод текста */,
  INPUT_NUMBER = 'input-number' /* Ввод числа */,
  INPUT_DATE = 'input-date' /* Ввод даты */,
  SWITCH = 'switch' /* Переключатель между булевскими значениями */,
  PROGRESS_BAR = 'progress-bar' /* Инпут для выбора отрезка от [a; max], где max - приходит с API */,
  NAVIGATION = 'navigation' /** Ячейка, которая подгружает дополнительные строчки в таблицу при клике на неё или перекидывает на плоскую таблицу */,
}
